"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var BaseNotification = /** @class */ (function (_super) {
    __extends(BaseNotification, _super);
    function BaseNotification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseNotification.prototype.markAsViewer = function (notification) {
        var _this = this;
        if (!notification.viewed) {
            this.$markNotificationAsViewed.request(notification).then(null, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
        }
    };
    return BaseNotification;
}(vue_1.default));
exports.default = BaseNotification;
